import { VerificationTypesEnum } from '@/lib/enum';
import { VerificationStateEnum } from '@/enums';
import { useQueryParams } from '@/hooks';
import type { TReportSource } from '../reportSources';
import { TTabname } from '..';

const useUrlParams = () => {

  const { values: [tab, state, type, source], setValue } = useQueryParams(
    ['tab', 'state', 'type', 'source'],
    {
      tab: 'users' as TTabname
    }
  );

  const changeState = (newState: VerificationStateEnum) =>
    setValue('state', newState);

  const changeTab = (newTab: TTabname | string) => {
    setValue('tab', newTab);
    !type &&
      changeType(VerificationTypesEnum.IDENTITY);
  };

  const changeType = (newType: VerificationTypesEnum) =>
    setValue('type', newType);

  const changeSource = (newSource: TReportSource) =>
    setValue('source', newSource);

  return ({
    state: state as (VerificationStateEnum | undefined),
    type: type as (VerificationTypesEnum | undefined),
    source: (source ?? 'all') as TReportSource,
    tab: tab as TTabname,
    changeSource,
    changeState,
    changeType,
    changeTab
  });

};

export default useUrlParams;
